<section [class.expand-on-hover]="hoverEnabled$ | async">
  <div class="top-header">
    <div class="logo" (click)="navigateToHomePage()" [attr.isCollapsed]="isSideNavCollapsed ? '1' : '0'">
      <img [src]="logo.icon" alt="logo" [style.width]="expandLogo ? '120px' : ''">
    </div>
    <button (click)="onCollapseToggleSideNav()" class="collapse-button" [attr.isCollapsed]="isSideNavCollapsed ? '1' : '0'">
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
  </div>
  <div class="side-nav-container" [attr.isCollapsed]="isSideNavCollapsed ? '1' : '0'">
    <app-side-nav 
      [isSideNavCollapsed]="isSideNavCollapsed" 
      [isSmallScreen]="isSmallScreen"
      [isEmptySideBar]="isEmptySideBar">
    </app-side-nav>
  </div>
  <div class="footer" [attr.isCollapsed]="isSideNavCollapsed ? '1' : '0'">
    <div class="profile" (click)="navigateToUserProfile($event)">
      <img src="../../../../assets/images/person-rounded.svg" alt="" />
      <div class="profile-details">
        <h5 class="ellipsis">{{user?.fullName}}</h5>
        <h6 class="ellipsis">{{user?.email}}</h6>
      </div>
    </div>

    <button class="logout" (click)="onLogout()">
      <mat-icon>logout</mat-icon>
      <span>{{"PROFILE_MENU.LOGOUT" | translate}}</span>
    </button>
  </div>
</section>


<ng-template #logoutPopup let-caller let-data="data" let-dialog="dialogRef">
  <app-modal-popup [matDialogRef]="dialog" [caller]="data?.caller" [confirmationData]="data?.data"></app-modal-popup>
</ng-template>